import { Loader } from 'kiswe-ui'
import { FanRoomScheduleActionType, FanRoomScheduleConfigType } from '../types'

export abstract class FanRoomScheduleConfigBase {
  team_id: string|null = null
  type: FanRoomScheduleConfigType
  version: string
  actions: FanRoomScheduleActionType[] = []

  constructor (data: unknown) {
    this.type = Loader.loadEnum(data, 'type', undefined, Object.values(FanRoomScheduleConfigType))
    const team_id = Loader.loadStringOrNull(data, 'team_id', this.team_id)
    if (this.type === FanRoomScheduleConfigType.Team && team_id === null) {
      throw new Error('team_id is required when type is Team')
    }
    this.team_id = team_id
    this.version = Loader.loadString(data, 'version')
    this.actions = Loader.loadArray<FanRoomScheduleActionType>(data, 'actions', this.actions)
  }
}
